@if (step(); as s) {
  @if (tour.minimized()) {
    <button
      type="button"
      class="tour-pill flex flex-align-center gap-sm"
      (click)="tour.restore()"
      data-testid="tour-resume-pill"
    >
      <app-icon name="compass" [size]="18" />
      <span>{{ 'tour.resume' | translate: progressParams() }}</span>
    </button>
  } @else {
    @if (highlight(); as h) {
      <div
        class="tour-highlight"
        [class.spotlight]="h.spotlight"
        [style.top.px]="h.top"
        [style.left.px]="h.left"
        [style.width.px]="h.width"
        [style.height.px]="h.height"
        data-testid="tour-highlight"
      ></div>
    }

    <section
      class="tour-card flex flex-column gap-sm p-lg"
      [class.at-top]="cardPlacement() === 'top'"
      [class.at-bottom]="cardPlacement() === 'bottom'"
      [class.centered]="cardPlacement() === 'center'"
      role="dialog"
      aria-live="polite"
      [attr.aria-label]="s.titleKey | translate: s.params"
      [attr.data-step]="s.id"
      data-testid="tour-card"
    >
      <header class="flex flex-align-center gap-sm">
        <span class="tour-progress mr-auto" data-testid="tour-progress">
          {{ 'tour.progress' | translate: progressParams() }}
        </span>
        <app-button
          variant="icon"
          (click)="tour.minimize()"
          [attr.aria-label]="'tour.minimize' | translate"
          data-testid="tour-minimize-button"
        >
          <app-icon name="minimize-2" [size]="18" />
        </app-button>
        <app-button
          variant="icon"
          (click)="tour.end()"
          [attr.aria-label]="'tour.close' | translate"
          data-testid="tour-close-button"
        >
          <app-icon name="x" [size]="18" />
        </app-button>
      </header>

      <h3 class="tour-title m-0" data-testid="tour-title">{{ s.titleKey | translate: s.params }}</h3>
      <div
        class="tour-body"
        data-testid="tour-body"
        [innerHTML]="s.bodyKey | translateMarkdown: s.params"
      ></div>

      @if (s.onSiteKey) {
        <div class="tour-onsite flex gap-sm p-sm" data-testid="tour-onsite">
          <app-icon name="smartphone" [size]="20" />
          <div class="flex flex-column">
            <strong>{{ 'tour.onSiteHeading' | translate }}</strong>
            <span [innerHTML]="s.onSiteKey | translateMarkdown: s.params"></span>
          </div>
        </div>
      }

      <footer class="flex flex-align-center flex-wrap gap-sm mt-sm">
        @if (!tour.isFirst()) {
          <app-button
            variant="text"
            (click)="back()"
            [disabled]="busy()"
            data-testid="tour-back-button"
          >
            {{ 'tour.back' | translate }}
          </app-button>
        }
        <span class="mr-auto"></span>
        @if (s.action; as a) {
          <app-button
            variant="filled"
            (click)="action()"
            [disabled]="busy()"
            data-testid="tour-action-button"
          >
            @if (a.icon) {
              <app-icon [name]="a.icon" [size]="18" />
            }
            {{ a.labelKey | translate: s.params }}
          </app-button>
        }
        <app-button
          [variant]="s.waitForUser || s.action ? 'outlined' : 'filled'"
          (click)="primary()"
          [disabled]="busy()"
          data-testid="tour-next-button"
        >
          {{
            (tour.isLast() ? 'tour.finish' : s.waitForUser ? 'tour.skipStep' : 'tour.next')
              | translate
          }}
        </app-button>
      </footer>
    </section>
  }
}
